import React from "react";
import styles from "../../components/card/Carddata.module.css";
import { Cardinfo, cardVariants } from "../../controller/Cardinfo";
import CardWidget from "../../components/card/Carddata";

function DataCard() {
  return (
    <div className={`container-fluid ${styles.ColourContainer}`}>
      <div className="row">
        <div className="text-center ">
          <h5 className={`main_heading ${styles.section_heading}`}>
            Explore Our Digital Solutions
          </h5>
        </div>

          {/* Single row with gap */}
          {Cardinfo.map((item, index) => (
            <CardWidget
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              paragraph={item.description}
              list={item.list}
              variants={cardVariants[index % cardVariants.length]}
              row={3}
            />
          ))}
      </div>
    </div>
  );
}

export default DataCard;
